document.addEventListener("DOMContentLoaded", () => {
  // Mobile menu: close drawer when navigating to an anchor link
  document.querySelectorAll(".mobile-menu__link").forEach((link) => {
    link.addEventListener("click", function () {
      const href = this.getAttribute("href");
      if (href && href.includes("#")) {
        document.getElementById("mobile-menu-toggle").checked = false;
      }
    });
  });

  // Cart quantity controls
  const cartForm = document.querySelector(".cart__form");
  if (cartForm) {
    const quantityInputs = cartForm.querySelectorAll(".cart__quantity-input");
    const decreaseBtns = cartForm.querySelectorAll(
      '[data-quantity="decrease"]',
    );
    const increaseBtns = cartForm.querySelectorAll(
      '[data-quantity="increase"]',
    );

    const DEBOUNCE_DELAY = 500;
    const updateTimeouts = new Map();

    function updateCartItem(itemId, newQuantity) {
      const formData = new FormData();
      formData.append("updates[" + itemId + "]", newQuantity);
      fetch("/cart/update.js", { method: "POST", body: formData })
        .then((r) => r.json())
        .then(() => window.location.reload())
        .catch((err) => console.error("Error updating cart:", err));
    }

    function debouncedUpdateCartItem(itemId, newQuantity) {
      if (updateTimeouts.has(itemId)) clearTimeout(updateTimeouts.get(itemId));
      const id = setTimeout(() => {
        updateCartItem(itemId, newQuantity);
        updateTimeouts.delete(itemId);
      }, DEBOUNCE_DELAY);
      updateTimeouts.set(itemId, id);
    }

    quantityInputs.forEach((input) => {
      input.addEventListener("input", () => {
        const itemId = input.getAttribute("data-item-id");
        debouncedUpdateCartItem(itemId, parseInt(input.value) || 0);
      });
    });

    decreaseBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const itemId = btn.getAttribute("data-item-id");
        const input = cartForm.querySelector(`input[data-item-id="${itemId}"]`);
        if (input) {
          const newValue = Math.max(0, parseInt(input.value) - 1);
          input.value = newValue;
          debouncedUpdateCartItem(itemId, newValue);
        }
      });
    });

    increaseBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const itemId = btn.getAttribute("data-item-id");
        const input = cartForm.querySelector(`input[data-item-id="${itemId}"]`);
        if (input) {
          const newValue = parseInt(input.value) + 1;
          input.value = newValue;
          debouncedUpdateCartItem(itemId, newValue);
        }
      });
    });
  }

  // Shopify Forms app — override CSS custom properties to match theme
  setTimeout(() => {
    const formContainer = document.querySelector("#app-embed");
    if (!formContainer) return;

    const overrides = {
      "--form-background-color": "var(--color-background)",
      "--form-text-color": "var(--color-foreground)",
      "--form-placeholder-color":
        "color-mix(in srgb, var(--color-foreground), transparent 50%)",
      "--body-text-color": "var(--color-foreground)",
      "--heading-text-color": "var(--color-foreground)",
      "--button-background-color": "var(--color-foreground)",
      "--button-text-color": "var(--color-background)",
      "--forms-accent-color": "var(--color-accent)",
      "--link-text-color": "var(--color-accent)",
      "--form-field-border-radius": "var(--style-border-radius-inputs)",
      "--button-border-radius": "var(--style-border-radius-inputs)",
      "--forms-body-font":
        "normal var(--font-primary--weight) 16px var(--font-primary--family)",
      "--forms-heading-font":
        "normal var(--font-primary--weight) 24px var(--font-primary--family)",
    };

    for (const [prop, value] of Object.entries(overrides)) {
      formContainer.style.setProperty(prop, value);
    }
  }, 2000);
});

// Product quantity controls — event delegation so it works after any DOM updates
document.addEventListener("click", function (event) {
  const button = event.target.closest("[data-quantity]");
  if (!button) return;

  const wrapper = button.closest(".product__quantity-wrapper");
  if (!wrapper) return;

  const quantityInput = wrapper.querySelector(".product__quantity-input");
  if (!quantityInput) return;

  const currentValue = parseInt(quantityInput.value) || 1;

  if (button.dataset.quantity === "decrease" && currentValue > 1) {
    quantityInput.value = currentValue - 1;
  } else if (button.dataset.quantity === "increase") {
    quantityInput.value = currentValue + 1;
  }
});
